<template>
  <div>
    <v-btn color="secondary" @click.native.stop.prevent="toggleModal">
      Update
    </v-btn>
    <v-dialog v-model="isModalOpen" max-width="630px" persistent >
      <v-toolbar dark color="primary" class="d-flex justify-center align-center">
        <v-toolbar-title class="body-heading-small">Update Avatar</v-toolbar-title>
      </v-toolbar>
      <v-card tile class="modal-content-container">
        <v-card-title>
          <span class="body-heading-small">Choose New Avatar Image</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isUpdateAvatarFormValid" ref="updateAvatarForm" @submit.prevent="update">
            <v-row>
              <v-col cols="12" md="12">
                <v-file-input :rules="avatarRules" prepend-inner-icon="fa-camera" prepend-icon="" outlined dense accept="image/png, image/jpeg, image/bmp" placeholder="Pick an avatar" label="Avatar" v-model="avatarSrc" clearable />
              </v-col>
            </v-row>
            <v-row class="px-3 justify-space-between">
              <v-btn color="secondary" class="modal-btn" type="submit" :disabled="!isUpdateAvatarFormValid">
                Save
              </v-btn>
              <v-btn color="secondary" class="modal-btn" outlined @click="toggleModal">Close</v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "UpdateAvatarModal",
    data() {
      return {
        isUpdateAvatarFormValid: false,
        isModalOpen: false,
        avatarSrc: null,
        avatarRules: [(v) => !!v || "Field cannot be empty.", (v) => !v || v.size < 2000000 || "Avatar size should be less than 2 MB!"],
      };
    },
    props: {
      userId: {
        required: true,
      },
      userType: {
        required: true,
      },
    },
    methods: {
      reset() {
        this.isUpdateAvatarFormValid = false;
        this.avatarSrc = null;
      },

      toggleModal() {
        this.isModalOpen = !this.isModalOpen;
        this.reset();

        if (this.$refs.updateAvatarForm) {
          this.$refs.updateAvatarForm.resetValidation();
        }
      },

      update() {
        this.$store.commit("setLoadingStatus", true);
        let data = new FormData();

        if (this.userType === "child") {
          data.append("child[avatar]", this.avatarSrc);

          this.$http
            .put("/children", data)
            .then((response) => this.updateSuccess(response))
            .catch((error) => this.updateFail(error));
        }

        if (this.userType === "parent") {
          data.append("parent[avatar]", this.avatarSrc);

          this.$http
            .put("/parents", data)
            .then((response) => this.updateSuccess(response))
            .catch((error) => this.updateFail(error));
        }
      },

      updateSuccess(response) {
        this.$router.go();
        this.$store.commit("setLoadingStatus", false);
      },

      updateFail(error) {
        console.error(error);
        this.$store.commit("setError", {
          message: "Failed to update avator, please try again later",
          type: "error",
        });
        if (this.$refs.updateAvatarForm) {
          this.$refs.updateAvatarForm.resetValidation();
        }
        this.$store.commit("setLoadingStatus", false);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/UpdateAvatarModal.vue